import { Component, computed, inject, signal } from '@angular/core';
import { RestaurantConfigService } from '../../services/restaurant-config.service';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
  imports: [
    NgOptimizedImage
  ]
})
export class GalleryComponent {
  private readonly restaurantConfig = inject(RestaurantConfigService);

  lightboxImage = signal<string | null>(null);

  readonly images = computed(() =>
    this.restaurantConfig
      .gallery()
      .slice(1)
      .map((g) => ({
        src: g.imageUrl,
        alt:
          g.altText?.trim() ||
          'Kanyar Büfé Pákozd – fogások és hangulat a Velencei-tó partján',
      }))
  );

  openLightbox(src: string) {
    this.lightboxImage.set(src);
  }

  closeLightbox() {
    this.lightboxImage.set(null);
  }
}
